// Co-Counsel names in Salesforce (Co_counse__c.Name) carry admin tags such as
// "[COOR] Ana", "[PG] [MAT] Daniel", "Hebert [T]", "Max Oliveira - Discontinued",
// "Jose Bastos | Salic" or "Eva (did not provide the full name)".
// Display-only: never use the cleaned value as an identifier or API parameter.
const LEADING_TAG = /^\s*\[[^\]]*\]\s*/;
const TRAILING_TAG = /\s*\[[^\]]*\]\s*$/;
const TRAILING_SPACED_DASH = /^(.*\S)\s+[-–—]\s+.*$/;
const TRAILING_PIPE = /\s*\|.*$/;
const TRAILING_PARENTHETICAL = /\s*\([^()]*\)\s*$/;

const stripOnce = (name) =>
  name
    .replace(LEADING_TAG, "")
    .replace(TRAILING_TAG, "")
    .replace(TRAILING_PIPE, "")
    .replace(TRAILING_SPACED_DASH, "$1")
    .replace(TRAILING_PARENTHETICAL, "")
    .trim();

export const cleanCoCoName = (name) => {
  if (name === null || name === undefined) return "";
  const original = String(name).replace(/\s+/g, " ").trim();
  let current = original;
  for (let i = 0; i < 20; i += 1) {
    const next = stripOnce(current);
    if (next === current) break;
    current = next;
  }
  return current || original;
};

export default cleanCoCoName;
